import { Box, Button } from '@mui/material'

interface SubmitButtonProps {
  onClick: () => void
  label: string
}

const SubmitButton = ({ onClick, label }: SubmitButtonProps) => {
  return (
    <Box my={7}>
      <Button variant="contained" fullWidth color="primary" onClick={onClick}>
        {label}
      </Button>
    </Box>
  )
}

export default SubmitButton
